module.exports = {
      id: "icon-user-usage",
      viewBox: "0 0 50 50",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#icon-user",
      toString: function () {
        return this.url;
      }
    }